import Header from '../globals/header';
import gsap from 'gsap';
import { startIntro, revealIntro } from '../globals/intro-state';
import { prefersReducedMotion } from '../globals/motion';

class IntroAnimation {
	constructor($el) {
		this.$el = $el;
		this.$html = $('html');
		this.$bg = this.$el.find('[data-intro-animation="bg"]');
		this.$title = this.$el.find('[data-intro-animation="title"]');
		this.$stagger = this.$el.find('[data-stagger]');
		this.reducedMotion = prefersReducedMotion();
		this.init();
	}

	init = () => {
		startIntro();
		this.$html.addClass('overflow-hidden');
		Header.addOpacity0();

		this.timeline = gsap.timeline({
			onComplete: this.onAnimationComplete,
		});

		this.timeline.to(this.$bg, {
			y: 0,
			duration: 0.75,
			ease: 'power2.in',
		});

		this.timeline.to(this.$stagger, {
			opacity: 1,
			y: 0,
			duration: 0.75,
			stagger: 0.25,
			ease: 'power2.out',
		});

		this.timeline.to(this.$title, {
			fontSize: $('.header__link').css('fontSize'),
			duration: 0.75,
			delay: 0.5,
			ease: 'power2.in',
			onComplete: () => {
				Header.removeOpacity0();
			},
		});

		// Inhalt (z. B. Projekt-Slider) kurz vor Ende freigeben
		this.timeline.call(revealIntro, null, '-=0.5');

		// Bei "Bewegung reduzieren" direkt zum Endzustand springen
		if (this.reducedMotion) {
			this.timeline.progress(1);
		}
	};

	onAnimationComplete = () => {
		this.$html.removeClass('overflow-hidden');

		setTimeout(() => {
			this.$el.remove();
		}, this.reducedMotion ? 0 : 750);
	};
}

export default IntroAnimation;
